<template>
	<div>
		<div class="panel m-3">
			<PanelHeader :panel-header="panelHeader" />
			<div class="container pt-3 pb-3">
				<div class="columns">
					<InputWithValidation class="column" message="Bitte geben Sie einen Bezeichner ein!" :name="medicationFormName"
						:set-name="(name) => (medicationFormName = name)" label="Bezeichner der Darreichungsform" />
					<InputWithValidation class="column" message="Bitte geben Sie ein Kürzel ein!" :name="medicationFormSymbol"
						:set-name="(name) => (medicationFormSymbol = name)" label="Kürzel der Darreichungsform" />
				</div>
			</div>
		</div>
		<div class="m-5 buttons" style="display: flex">
			<CancelButton text="Abbrechen" back-route="/medication_form" :is-loading="false" />
			<SaveButton style="margin-left: auto" :is-loading="isLoading"
				:save-function="saveDataObject"
				:disabled="$v.medicationFormName.$invalid || $v.medicationFormSymbol.$invalid" />
		</div>
	</div>
</template>
  
<script>
/**
 * This file is for creating and editing medication forms.
 */
import Parse from "parse/dist/parse.min.js";
import { minLength, required } from "vuelidate/lib/validators";
import { negativeFeedBack, positiveFeedBack } from "@/lib/Toast";
import PanelHeader from "@/components/helperComponents/PanelHeader";
import InputWithValidation from "@/components/helperComponents/InputWithValidation";
import CancelButton from "@/components/helperComponents/CancelButton";
import SaveButton from "@/components/helperComponents/SaveButton";

export default {
	name: "NewMedicationForm",
	components: {
		SaveButton,
		CancelButton,
		InputWithValidation,
		PanelHeader,
	},
	data() {
		return {
			dataObject: undefined,
			isLoading: false,
			medicationFormName: "",
			medicationFormSymbol: "",
			panelHeader: "Neue Darreichungsform (Art) anlegen"
		};
	},
	computed: {},
	watch: {},
	mounted() {
		if (this.$route.params.data) {
			this.dataObject = this.$route.params.data
			this.medicationFormName = this.dataObject.attributes.name
			this.medicationFormSymbol = this.dataObject.attributes.symbol
			this.panelHeader = "Darreichungsform (Art) bearbeiten"
		}
	},
	validations: {
		medicationFormName: {
			required,
			minLength: minLength(1),
		},
		medicationFormSymbol: {
			required,
			minLength: minLength(1),
		},
	},
	methods: {
		async saveDataObject() {
			this.isLoading = true;
			const parseObject = Parse.Object.extend("MedicationForm")
			const dataObject = this.dataObject ? this.dataObject : new parseObject()
			dataObject.set("name", this.medicationFormName)
			dataObject.set("symbol", this.medicationFormSymbol)
			dataObject.set("deleted", false)
			await dataObject.save().catch((e) => {
				negativeFeedBack("Darreichungsform (Art) nicht gespeichert!")
			});
			this.isLoading = false;
			await this.$router.push({ path: "/medication_form" })
			await positiveFeedBack("Darreichungsform (Art) gespeichert!")
		},
	},
};
</script>
  
<style lang="scss" scoped>
.image_column {
	max-width: 200px;
}
</style>
  